<template>
  <div class="w-full">
    <form-edit-header v-model="form_name" :flowable="form.type === 'flowform'" active-index="1" />
    <div v-loading="loading">
      <fm-making-form
        ref="makingform"
        class="w-full"
        :data="jsonData"
        :forms="forms"
        style="height: calc(100vh - 106px);"
        preview
        generate-json
      >
        <template slot="action">
          <el-button type="text" icon="el-icon-upload" @click="submit">保存</el-button>
        </template>
      </fm-making-form>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import Layout from '@/Shared/Layout'
import zroute from '../../ziggy'
import FormEditHeader from '../../components/FormEditHeader'

export default {
  components: {
    FormEditHeader,
  },
  layout: Layout,
  props: {
    form: {
      type: Object,
      default: () => {
      },
    },
    forms: {
      type: Array,
      default: () => [] ,
    },
  },
  data() {
    return {
      form_name: this.form.name,
      loading: false,
      jsonData: {
        list: this.form.widgets,
        config: this.form.config ? this.form.config : {
          'labelWidth': 100,
          'labelPosition': 'right',
          'size': 'small',
          'customClass': '',
        },
      },
    }
  },
  created() {
    // this.$nextTick(() => {
    //   this.$refs.makingform.setJSON(this.jsonData)
    // })
  },
  mounted() {
    console.log('form mounted', this.jsonData)
    this.$nextTick(() => {
      this.$refs.makingform.setJSON(this.jsonData)
    })
  },
  methods: {
    getFromData() {
      // this.loading = true
      // getList({form_id: this.$route.params.id}).then(res => {
      //   this.loading = false
      //   // console.log(res)
      //   this.jsonData = res.data
      //   if (this.jsonData['config'].length === 0) {
      //     this.jsonData['config'] = {"labelWidth": 100, "labelPosition": "right", "size": "small", "customClass": ""}
      //   }
      //   // console.log(this.jsonData)
      //   this.$refs.makingform.setJSON(this.jsonData)
      // })
    },
    submit() {
      this.loading = true
      axios.post('edit/form', {data: this.$refs.makingform.getJSON()}).then(res => {
        this.loading = false
        this.$message({
          message: '保存成功',
          type: 'success',
        })
      }).catch(err => {
        this.loading = false
        this.$message({
          message: '保存失败',
          type: 'error',
        })
      })
      // saveForm({data: this.$refs.makingform.getJSON(), form_id: this.$route.params.id}).then(res => {
      //   this.loading = false
      //   this.$message.success('保存成功')
      //   console.log(res)
      // })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
